import React from 'react';
import ContributionLimits from './ContributionLimits';
import CampaignFinanceLaws from './components/CampaignFinanceLaws';
import PublicFinaceLaw from './components/PublicFinanceLaw';
import Regulations from './components/Regulations';
import AdvisoryOpinionIndex from './components/AdvisoryOpinionIndex'; 
import InterpretiveBulletinIndex from './components/InterpretiveBulletinIndex';
import MemorandaIndex from './components/MemorandaIndex';
import GuidanceLetters from './components/GuidanceLetters';
import IssuesOfInterest from './components/IssuesOfInterest';
import AgencyActions from './components/AgencyActions';

const routes = [
  {
    path: '/Legal/ContributionLimits',
    renderer: (params = {}): JSX.Element => <ContributionLimits {...params} />,
  },
  {
    path: '/Legal/CampaignFinanceLaw',
    renderer: (params = {}): JSX.Element => <CampaignFinanceLaws {...params} />,
  },
  {
    path: '/Legal/PublicFinancingLaw',
    renderer: (params = {}): JSX.Element => <PublicFinaceLaw {...params} />,
  },
  {
    path: '/Legal/Regulations',
    renderer: (params = {}): JSX.Element => <Regulations {...params} />,
  },
  {
    path: '/Legal/AdvisoryOpinionsIndex',
    renderer: (params = {}): JSX.Element => <AdvisoryOpinionIndex {...params} />,
  },
  {
    path: '/Legal/InterpretiveBulletinIndex',
    renderer: (params = {}): JSX.Element => <InterpretiveBulletinIndex {...params} />,
  },
  {
    path: '/Legal/MemorandaIndex',
    renderer: (params = {}): JSX.Element => <MemorandaIndex {...params} />,
  },
  {
    path: '/Legal/GuidanceLetters',
    renderer: (params = {}): JSX.Element => <GuidanceLetters {...params} />,
  },
  {
    path: '/Legal/IssuesOfInterest',
    renderer: (params = {}): JSX.Element => <IssuesOfInterest {...params} />,
  },
  {
    path: '/Legal/AgencyActions',
    renderer: (params = {}): JSX.Element => <AgencyActions {...params} />,
  },
];


export default routes;
